var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blue_person_Updated 1",
    clipPath: "url(#clip0_551_83688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.2227 57.2285H70.6227",
    stroke: "#007FAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.4853 21.2461C54.5909 21.2461 57.8691 24.5087 57.8691 28.6299C57.8691 32.751 54.6065 36.0605 50.4853 36.0605C46.3642 36.0605 43.1016 32.7979 43.1016 28.6767C43.1016 24.5555 46.4266 21.2461 50.4853 21.2461Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.7148 41.2586V63.5192C39.7148 65.4549 41.3539 67.094 43.2896 67.094V92.9138C43.2896 94.8495 44.9288 96.4886 46.8645 96.4886H54.2482C56.1839 96.4886 57.823 94.8495 57.823 92.9138V67.094C59.7587 67.094 61.3978 65.4549 61.3978 63.5192V41.2586C61.3978 39.3229 59.7587 37.6838 57.823 37.6838H43.0087C41.3696 37.3872 39.7461 39.0732 39.7461 41.2586",
    fill: "#6D6E71"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M9.52241 50.422C9.52241 27.6306 27.9428 9.67852 50.2658 9.67852C72.5889 9.67852 91.0093 28.0989 91.0093 50.422C91.0093 72.745 72.745 91.1654 50.422 91.1654C27.6306 91.4776 9.52241 73.2133 9.52241 50.422ZM0 50.422C0 78.3648 22.4791 100.844 50.422 100.844C78.3648 100.844 100.844 78.3648 100.844 50.422C100.688 22.7913 78.2087 0 50.422 0C22.6352 0 0 22.7913 0 50.422Z",
    fill: "#007FAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_551_83688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePerson);
export default __webpack_public_path__ + "static/media/blue_person.fafb637bee7d52e362f4fc90f15a055c.svg";
export { ForwardRef as ReactComponent };